import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGetPolicyInfo } from "utils/API/TrxNowAPI";
import { PolicyLookupSpinner } from "webapp/components/PolicyLookupSpinner";
import { AppState } from "webapp/enums/AppState";
// import "./APIAMemberInformationForm.scss";
import { devLog } from "utils/devLog";

const policyMap = new Map();
function ECCMemberInformationForm(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchValue, setSearchValue] = useState(props.currState.MemberLookup.accountRef);

  // const [memberNumber] = useState(props.currState.MemberLookup.memberNumber);
  const [make] = useState(props.currState.MemberLookup.make);
  const [model] = useState(props.currState.MemberLookup.model);
  const [year] = useState(props.currState.MemberLookup.year);
  const [color] = useState(props.currState.MemberLookup.color);
  const [accessCode] = useState(props.currState.MemberLookup.accessCode);
  const [firstName] = useState(props.currState.FirstName);
  const [lastName] = useState(props.currState.LastName);
  const [phoneNumber] = useState(props.currState.Number.replace(/[()\s-]/g, ""));
  // const [fullName] = useState(
  //   props.currState.FirstName + " " + props.currState.LastName
  // );

  const [searchType, setSearchType] = useState(props.currState.MemberLookup.searchType);
  const [contactInfo, setContactInfo] = useState(undefined);
  const [selectedMember, setSelectedMember] = useState(contactInfo);
  const [partnerCode, setPartnerCode] = useState(props.currState.localGroup);

  useEffect(() => {
    //devLog(props);
    onSubmit();
  }, []);

  const onLoad = (success) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(success);
    }
  };

  const onSelect = (member) => {
    //devLog("onSelect", member);
    setSelectedMember(member);
    if (!member) {
      return;
    }
    if (typeof props.onSelect === "function") {
      props.onSelect(member, member);
    }
  };

  const onUserCancel = (e) => {
    // e.preventDefault();
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };

  const onSubmit = (e) => {
    setError("");
    // e.preventDefault();
    //devLog("Execute policy search...", searchValue);

    if (policyMap.has(searchValue)) {
      setContactInfo(policyMap.get(searchValue));
      setLoading(false);
      onLoad(true);
      //devLog("searchValue: " + searchValue);
      return;
    }

    const memberData = searchValue;
    //devLog("memberData: " + memberData);

    setLoading(true);
    //Lookup: Callout
    apiGetPolicyInfo({
      data: {
        providerRef: props.currState.providerRef,
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        accessCode: accessCode,
        searchType: searchType,
        partnerCode: partnerCode,
        // memberNumber: memberNumber,
        // make: make,
        // model: model,
        // year: year,
        // color: color,
      },
      companyParams: props.currState.currentCompanyParams,
    })
      //Lookup: Success
      .then((json) => {
        devLog("JSON", json.data);
        if (typeof json.data.contactInfo === "object") {
          if (!json.data.error) {
            //devLog("contactInfo", json.data.contactInfo);
            setContactInfo(json.data.contactInfo);
            setLoading(false);
            onLoad(true);
            props.context.setState(
              {
                contactRef: json.data.contactInfo[0].contactRef ? json.data.contactInfo[0].contactRef : "",
                Year: json.data.contactInfo[0].year ? json.data.contactInfo[0].year : "",
                Make: json.data.contactInfo[0].make ? json.data.contactInfo[0].make : "",
                Model: json.data.contactInfo[0].model ? json.data.contactInfo[0].model : "",
                Color: json.data.contactInfo[0].color ? json.data.contactInfo[0].color : "",
                webAppState: AppState.ConfirmVehicle,
              },
              () => {},
            );

            onSelect(json.data.contactInfo[0], json.data.contactInfo[0]);
          } else {
            setError(json.data.error.message);
            onLoad(false);
          }
        } else if (json?.data?.inactive !== null && json?.data?.inactive) {
          setError(t("description.ExpiredAccessCode"));
          onLoad(false);
        } else if (json?.data?.transitToNewProvider !== null && json?.data?.transitToNewProvider) {
          setError(t("description.TransitToNewProvider"));
          props.context.setState({
            ShowMessage: true,
            MessageTitle: "TransitToNewProvider",
            Message: "TransitToNewProviderMessage",
            MessagePreventDismiss: false,
            MessageHidePrimaryButton: false,
            MessageButtonTitle: "SearchAgain",
            onUserModalConfirm: () => {
              props.context.setState(
                {
                  webAppState: AppState.MemberSearch,
                },
                () => {
                  props.context.saveWebAppState(props.context);
                },
              );
            },
            MessageSecondButtonTitle: "CancelCallAction",
            MessageSecondAction: onUserCancel,
          });
          onLoad(false);
        } else if (typeof json.data.error === "object") {
          setError(json.data.error.message);
          policyMap.delete(searchValue);
          onLoad(false);
        } else {
          setError(t("APIA.PolicyInformation.UnableToFindMember"));
          policyMap.delete(searchValue);
          onLoad(false);
        }
        setLoading(false);
      })

      //Lookup: Failed
      .catch((e) => {
        devLog("catch error", e);

        setLoading(false);
        setError(t("APIA.PolicyInformation.UnableToFindMember"));
        onLoad(false);
      });
  };

  const onUserBack = (e) => {
    e.preventDefault();
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  return (
    <>
      {/* <div className="formContainer">
        {contactInfo ? (
          <div className="policyData">
            <div className="policyHeader">
              <h4>{t("description.ContractInformationHeader2")}</h4>
              <hr />
              <div className="policy-info-line">
                <b>Name</b>: {contactInfo[0].firstName}{" "}
                {contactInfo[0].lastName}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>Access Code</b>: {accessCode}
              </div>
              <hr />
            </div>
          </div>
        ) : (
          <></>
        )}{" "}
      </div> */}

      {error ? (
        <div className="errorSection">
          <b className="error"> {error}</b>
          <div>
            <button className="ui-btn" onClick={onUserBack}>
              {t("description.TryAgain")}
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
      {loading ? <PolicyLookupSpinner title={`ContractLookupTitleARI`} message={`PolicyLookupMessage`} /> : <></>}
    </>
  );
}

export default ECCMemberInformationForm;
